/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bestScore: NonNullable<unknown>, scores: NonNullable<unknown> }} Course_Status_Passed_Attempts_SubInputs */

const en_course_status_passed_attempts_sub = /** @type {(inputs: Course_Status_Passed_Attempts_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Best score: ${i?.bestScore}% (All attempts: ${i?.scores})`)
};

const ja_course_status_passed_attempts_sub = /** @type {(inputs: Course_Status_Passed_Attempts_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最高得点: ${i?.bestScore}%（全試行: ${i?.scores}）`)
};

const fr_course_status_passed_attempts_sub = /** @type {(inputs: Course_Status_Passed_Attempts_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meilleur score : ${i?.bestScore}% (Toutes les tentatives : ${i?.scores})`)
};

const de_course_status_passed_attempts_sub = /** @type {(inputs: Course_Status_Passed_Attempts_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beste Punktzahl: ${i?.bestScore}% (Alle Versuche: ${i?.scores})`)
};

/**
* | output |
* | --- |
* | "Best score: {bestScore}% (All attempts: {scores})" |
*
* @param {Course_Status_Passed_Attempts_SubInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_status_passed_attempts_sub = /** @type {((inputs: Course_Status_Passed_Attempts_SubInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Status_Passed_Attempts_SubInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_status_passed_attempts_sub(inputs)
	if (locale === "ja") return ja_course_status_passed_attempts_sub(inputs)
	if (locale === "fr") return fr_course_status_passed_attempts_sub(inputs)
	return de_course_status_passed_attempts_sub(inputs)
});